import { Box, Flex, Grid, Text, Heading, Card, Button, AlertDialog } from '@radix-ui/themes';
import { useState, useEffect } from 'react';
import StudentFeedBrowser from '../student/StudentFeedBrowser';
import { useSelector, useDispatch } from 'react-redux';
import { getWeeklyQuizSummaries } from '../../api/quiz';
import LoadingIndicator from '../shared/LoadingIndicator';
import { quizService } from '../../services/student/quizService';
import StudentProgressSummary from '../student/StudentProgressSummary';
import LinkGuardian from '../forms/student/LinkGuardian';
import MessageBox from '../common/MessageBox';
import PaymentCheck from '../common/PaymentCheck';
const StudentDashboard = () => {
  const user = useSelector((state) => state.user);
  const [feed, setFeed] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openQuizDialog, setOpenQuizDialog] = useState(true);

  const quizzes = useSelector((state) => state.studentAccount.quizzes);
  const dispatch = useDispatch();

  const getFeed = async () => {
    setLoading(true);
    try {
      const response = await quizService.getFeed();
      if (response.message) {
        console.log('Student feed response message', response.message);
      }
      setFeed(response);
      console.log('Feed response', response)
    } catch (error) {
      console.error('Error fetching quizzes:', error);
      return [];
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getFeed();
  }, [quizzes]);

  const handleQuizSelect = (quiz) => {
    console.log('Quiz selected:', quiz);
  };

  if (loading) {
    return <LoadingIndicator />;
  }

  return (
    <Box width="100%" maxWidth="1080px">
      <Grid columns={{ initial: "1", sm: "2" }} gap="4">
        <Box>
          <StudentFeedBrowser quizzesSummary={feed} onQuizSelect={handleQuizSelect} onQuizComplete={getFeed} />
        </Box>
        <Box style={{
          gridColumnStart: { initial: '1', sm: '2' },
          gridRowStart: { initial: '2', sm: '1' },
          gridColumnEnd: { initial: '2', sm: '3' },
          gridRowEnd: { initial: '3', sm: '2' }
        }}>
          <Card>
            <PaymentCheck>
              <StudentProgressSummary />
            </PaymentCheck>
          </Card>
        </Box>
      </Grid>
    </Box>
  );
};

export default StudentDashboard;
